export default __webpack_public_path__ + "static/media/Blue-lagoon01.42a2db72.webp";